// extracted by mini-css-extract-plugin
export var actionButton = "_x6-2";
export var card = "_x6-0";
export var errorCard = "_x6-1";